<template>
    <div class="form-constructor">
        <div class="container">
            <ListOfForms
                v-if="mode === MODES.LIST"
                :forms="forms"
                :onEditForm="onEditForm"
                :onDeleteForm="onDeleteForm"
                :onDuplicateForm="onDuplicateForm"
                :onCreate="onCreate"
            />
            <FormContructor
                :editData="editData"
                :statuses="statuses"
                :sources="sources"
                :portal_fields="portal_fields"
                :onAfterSave="onAfterSave"
                v-if="mode === MODES.ADD || mode === MODES.EDIT"
            />
        </div>
    </div>
</template>

<script>
import ListOfForms from "./components/List.vue";
import FormContructor from "./components/Form.vue";
import axios from "axios";

export default {
    name: "Contructor",
    props: ["form_list", "portal_fields", "sources", "statuses"],
    data() {
        return {
            editData: null,
            MODES: {
                LIST: "list",
                ADD: "add",
                EDIT: "edit",
            },
            mode: null,
            forms: [],
        };
    },
    components: {
        ListOfForms,
        FormContructor,
    },
    mounted() {
        this.mode = this.MODES.LIST;
        this.forms = JSON.parse(this.form_list);

        if (this.forms.length) {
            this.onEditFormByURL();
        }
    },
    methods: {
        onCreate() {
            this.mode = this.MODES.ADD;
        },

        onAfterSave() {
            this.mode = this.MODES.LIST;
            this.editData = null;
            location.reload();
        },

        onEditForm(id) {
            const form = this.forms.find((__form) => __form.id === id);

            this.editData = form;

            this.mode = this.MODES.EDIT;
        },

        async onDuplicateForm(id) {
            await axios
                .post(`/admin-panel/forms/duplicate`, {
                    form_id: id
                })
                .then((res) => {
                    const { form_id } = res.data;

                    window.location.href = `/admin-panel/forms?form_id=${form_id}`;
                })
                .catch((err) => console.error("Error in onDuplicateForm", err));
        },

        async onDeleteForm(id) {
            await axios
                .delete(`/admin-panel/forms/${id}`)
                .then(() => {
                    this.forms = this.forms.filter((f) => f.id !== id);
                })
                .catch((err) => console.error("Error in onDeleteForm", err));
        },

        onEditFormByURL() {
            const urlParams = new URLSearchParams(window.location.search);

            console.log(urlParams.get("form_id"));

            if (urlParams.has("form_id")) {
                const form_id = urlParams.get("form_id");

                this.onEditForm(Number(form_id));
            }
        },
    },
};
</script>
